import {
    FONT_CHANGE_EVENT,
    FONT_DEFAULT,
    FONT_STORAGE_KEY,
} from "../constants";
import { usePersistedSetting } from "./usePersistedSetting";

/**
 * Manages the user's preferred code-block font family.
 *
 * The selected font label is persisted in localStorage and kept in sync
 * across all mounted consumers via the {@link FONT_CHANGE_EVENT} window event.
 *
 * @returns An object containing:
 *   - `fontLabel` - The currently selected font label (e.g. `"Fira Code"`).
 *     Defaults to `"Default"` when nothing has been stored.
 *   - `handleFontChange` - A setter that persists a new font label and
 *     notifies other mounted consumers.
 */
export function useCodeFont() {
    const [fontLabel, setFontLabel] = usePersistedSetting(
        FONT_STORAGE_KEY,
        FONT_DEFAULT,
        FONT_CHANGE_EVENT
    );

    return { fontLabel, handleFontChange: setFontLabel } as const;
}
